import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Environment } from 'src/environments/environment.model';

import { GetTgaCropIdsResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class TgaService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.API_BASE_URL}/service/field-advice/secure/`;

  getAvailableTgaCropIds(): Observable<number[]> {
    return this.http
      .get<GetTgaCropIdsResponse>(`${this.baseUrl}tga/cropids`)
      .pipe(map((d) => d.ids));
  }
}
